import { createSlice } from '@reduxjs/toolkit';

const collectionSlice = createSlice({
  name: 'collectionSlice',
  initialState: {
    collection: [],
    totalRowCount: 0,
    iscollectionLoading: false,
  },
  reducers: {
    setCollection: (state, action) => {
      state.collection = action.payload.data.collection;
      state.totalRowCount = action.payload.data.totalRowCount;
    },
    setCollectionLoading: (state, action) => {
      state.iscollectionLoading = action.payload;
    },
  },
});

export const { setCollection, setCollectionLoading } = collectionSlice.actions;
export default collectionSlice.reducer;
